import React, { useRef, useState, useEffect } from "react";
import "./style.scss";
import classNames from "classnames";
import { BackgroundImage, BodyText, Heading } from "../../elements";
import { getOverallSettingsClasses, loadScrollMagic, mobileIs } from "../../utils/siteUtils";
import gsap from "gsap";


let globalActiveIndex = -1; 
let globalInitActive = false; 
const RollingSlider = props => {
  const { fields, rendering } = props;
  const { List } = fields;

  const rootEl = useRef(null);
  const titleEl = useRef(null);
  const rootId = `rolling-slider__${rendering.uid}`;
  const mainId = `rolling-slider__main${rendering.uid}`;
  const [activeIndex, setActiveIndex] = useState(0);
  const [oldActiveIndex, setOldActiveIndex] = useState('-1');
  const [direction, setDirection] = useState('FORWARD');
  const [initActive, setInitActive] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const [newItems] = useState(() => {
    let list = [...List];
    let arr = list?.length ? list : [];
    return arr;
  });

  const addItemClass = itemId => {
    let list = [...List];
    (list || []).map((item, index) => {
      const itemId = `rolling-sliderItemId__${item.id}`;
      let otheritemsEle = document.querySelector(`#${itemId} .rolling-slider__item-main`);
      otheritemsEle.classList.remove("rolling-slider__item__text-animation");
    });
    let itemEle = document.querySelector(`#${itemId} .rolling-slider__item-main`);
    itemEle.classList.add("rolling-slider__item__text-animation");
  };
  useEffect(() => {
    const ScrollMagic = loadScrollMagic();
    let controller = new ScrollMagic.Controller();
    const tl = gsap.timeline();
    let list = [...List];
    let scene = new ScrollMagic.Scene({
      triggerElement: `#${rootId}`,
      triggerHook: "onLeave",
      duration: `${List?.length * 120}%`
    })
      .setPin(`#${mainId}`)
      .setTween(tl)
      .addTo(controller);
    if (List?.length === 1) {
      scene.removePin(true);
    }
    scene.on("start", function(event) {
      let itemId = `rolling-sliderItemId__${list[0]?.id}`;
      addItemClass(itemId);
    });
    scene.on("progress", function(event) {
      let ep = event.progress;
      let es = event.scrollDirection;
      var base = 1/list.length;
      if(es === 'FORWARD'){
        for( var i=0;i<list.length;i++){
          if(ep > (base * (i+1)) && ep < (base * (i+2)) ){
            tab(i+1,i,'FORWARD')
          }
        }
      }
      if( es === 'REVERSE' ){
        for( var i=0;i<list.length-1;i++){
          if( ep > (base * (i)) && ep < (base * (i+1))){
            tab(i,i+1,'REVERSE')
          }
        }
      }
    })
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      scene.destroy(true);
      scene = null;
      controller.destroy(true);
      controller = null;
    };
  }, []);

  const tab = (index, oldIndex, direction) => {
    setInitActive(false)
    globalActiveIndex = index
    setDirection(direction)
    setOldActiveIndex(oldIndex)
    setActiveIndex(index)
  }
  const onScroll = () => {
    if(rootEl.current){
      let top = rootEl.current.getBoundingClientRect().top;
      let winheight = window.innerHeight;
      let height = rootEl.current.getBoundingClientRect().height;
      if( Math.abs(top) > height && top<0){
        setActiveIndex(newItems.length-1)
        globalActiveIndex = newItems.length-1
      }
      if(Math.abs(top) < winheight*0.7 && top>0 && !globalInitActive){
          setInitActive(true)
          globalInitActive = true
          setTimeout(v=>{
            setInitActive(null)
            globalInitActive = null
          },10)
      }

      if(top < winheight*0.5) {
        setIsActive(true)
      } else {
        setIsActive(false)
      }
    }
  }
  const TextClasses = classNames("rolling-slider", getOverallSettingsClasses(fields));

  return (
    <div id={rootId} className={TextClasses} datasourceid={rendering.dataSource} ref={rootEl}>
      <div className={"rolling-slider__main grid"} id={mainId}>
        {(newItems || []).map((item, index) => {
          const { Position:alignment, HeadingType:headingType, Title:headingBody, Title_Mobile:mobile_headingBody, SubTitle, SubTitle_Mobile, Description:body, Description_Mobile:mobile_body, cta, Background_PC:pc_image, Background_Mobile:mobile_image, shadow } = item.fields;
          const backgroundImage = mobileIs() ? mobile_image : pc_image;
          let headingValue = mobileIs() ? mobile_headingBody : headingBody;
          let subTitle = mobileIs() ? SubTitle_Mobile : SubTitle;
          let bodyValue = mobileIs() ? mobile_body : body;
          const itemClasses = classNames(
            "rolling-slider__item grid", 
            alignment.value,
            index === 0 && initActive ? 'initActive' : null,
            activeIndex === index && direction === 'REVERSE'?'activeReverse': null, 
            activeIndex === index && direction  === 'FORWARD'?'active': null, 
            isActive && index === activeIndex ? 'animate_active' : null,
            index === oldActiveIndex ?'oldeActive': null, 
          );
          const itemId = `rolling-sliderItemId__${item.id}`;
          let newBackgroundImage = backgroundImage;
          if (shadow?.value) {
            newBackgroundImage = {
              ...backgroundImage,
              value: {
                image: `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 23.38%), url(${backgroundImage.value?.src})`
              }
            };
          }
          return (
            <div id={itemId} className={itemClasses} key={index}>
              <div className="rolling-slider__item__image">
                <BackgroundImage {...newBackgroundImage} className={"rolling-slider__item-image"} />
              </div>

              <div className="rolling-slider__text-background"></div>

              <div className={"rolling-slider__image-intro"}>
                <Heading className={"rolling-slider__image-title"} type={headingType} html={headingValue} ref={titleEl} />
                <div className="rolling-slider__image-subtitle">
                  <p>{subTitle.value}</p>
                </div>
                <div className="rolling-slider__image-detail">
                  <BodyText  html={bodyValue} />
                </div>
              </div>

            </div>
          );
        })}
      </div>
    </div>
  );
};
export default RollingSlider;
